import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import InsurerList from './InsurerList';

const InsurerListPage = () => {
    const { t } = useTranslation('insurerList');

    const goToNewInsurerPage = useGoTo('/admin/insurers/add');
    const { permissions: accountPermissions } = useAccount();

    const extra = hasPermissions(accountPermissions, [permissionKind.createInsurer]) && (
        <Button icon={<PlusOutlined />} onClick={goToNewInsurerPage} type="primary">
            {t('insurerList:actions.newInsurer')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('insurerList:title')}>
            <InsurerList />
        </ConsolePageWithHeader>
    );
};

export default InsurerListPage;
